import { createSelector } from 'reselect'
import { getAccommodationItems } from 'checkout/selectors/view/accommodation'
import { isSpoofed } from 'selectors/featuresSelectors'
import {
  isBedbankItem,
  isLEHotelItem,
  isBNBLLEHotelItem,
  isInstantBookingLEHotelItem,
} from 'lib/checkout/checkoutUtils'
import { depositDisabled, getLeHotelDepositInfo } from 'lib/payment/depositsUtils'
import { buildAvailableRateKey } from 'lib/offer/availabilityUtils'
import config from 'constants/config'

const getItemsDepositInfo = createSelector(
  (state: App.State) => getAccommodationItems(state),
  (state: App.State) => state.offer.offers,
  (state: App.State) => state.offer.offerAvailableRates,
  (state: App.State) => state.checkout.cart.isGift,
  (state: App.State) => isSpoofed(state),
  (accommodationItems, offers, offersAvailableRates, isGift, isSpoofed): Array<App.Checkout.ItemDepositInfo> => {
    return accommodationItems
      .map((item) => {
        // Gift items should never be Deposit orders
        if (isGift) {
          return depositDisabled(item)
        }

        if (isBedbankItem(item)) {
          if (item?.bundledItemIds?.length) {
            return { itemId: item.itemId }
          }
          return depositDisabled(item)
        }

        if (!isLEHotelItem(item)) {
          return depositDisabled(item)
        }

        // Disable deposits if specified at an offer level
        if (offers[item.offerId]?.disableDeposit) {
          return depositDisabled(item)
        }

        if (isInstantBookingLEHotelItem(item)) {
          const offer = offers[item.offerId]
          const availableRatesKey = buildAvailableRateKey(item.checkIn, item.checkOut, [item.occupancy])
          // all available room rates, using only if flag useDynamicCancellationPolicies is true
          const offerAvailableRates = offersAvailableRates?.[item.offerId]?.[availableRatesKey]
          return offer ? getLeHotelDepositInfo(item, offer, offerAvailableRates) : depositDisabled(item)
        }

        if (isBNBLLEHotelItem(item) && !config.BNBL_DEPOSITS_ENABLED && !isSpoofed) {
          return depositDisabled(item)
        }

        // multi-room should be disabled for BNBL for deposits
        if (accommodationItems.filter(item => isBNBLLEHotelItem(item)).length > 1) {
          return depositDisabled(item)
        }

        // BNBL items, have no dates
        return {
          itemId: item.itemId,
        }
      })
  },
)

export default getItemsDepositInfo
